import type { IconData } from '@stacksjs/iconify-core'

export const male: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4.364 14.636a5 5 0 1 0 7.071-7.071a5 5 0 0 0-7.071 7.071m7.728-9.142l2.553-2.553h-1.517a1 1 0 0 1 0-2h4a.997.997 0 0 1 1 1v4a1 1 0 1 1-2 0V4.286l-2.622 2.622A7.002 7.002 0 0 1 2.95 16.05a7 7 0 0 1 9.142-10.556\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default male
